import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { Button } from "react-bootstrap";
import ReactSelect from "../../UI/ReactSelect";
import axios from "axios";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs, setFilterInputs, structureId, } = props;
  const [chooseStructureIdOption, setChooseStructureIdOption] = useState([]);

  const [department, setDepartment] = useState();
  const [directorate, setDirectorate] = useState();
  const [branch, setBranch] = useState();
  const [division, setDivision] = useState();
  const [structureType, setStructureType] = useState();

  const [chooseDepartmentOption, setChooseDepartmentOption] = useState([]);
  const [chooseDirectorateOption, setChooseDirectorateOption] = useState([]);
  const [chooseBranchOption, setChooseBranchOption] = useState([]);
  const [chooseDivisionOption, setChooseDivisionOption] = useState([]);
  const [chooseStructureTypeOption, setChooseStructureTypeOption] = useState([]);


  function handleChangeStructure(value) {
    setChooseStructureIdOption(value);
    filterInputsUpdate("structureId", value ? value.value : "");
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP&id=${value ? value.value : ""}`)
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type
        }))

        const newDepartmentItem = displayTypes.filter(obj => {
          return obj.type === 'DEPARTMENT';
        });
        const newDirectorateItem = displayTypes.filter(obj => {
          return obj.type === 'DIRECTORATE';
        });
        const newBranchItem = displayTypes.filter(obj => {
          return obj.type === 'BRANCH';
        });
        const newDivisionItem = displayTypes.filter(obj => {
          return obj.type === 'DIVISION';
        });
        const newStructureTypeItem = displayTypes.filter(obj => {
          return obj.type === 'STRUCTURE_TYPE';
        });
        setDepartment(newDepartmentItem);
        setDirectorate(newDirectorateItem)
        setBranch(newBranchItem);
        setDivision(newDivisionItem)
        setStructureType(newStructureTypeItem)

        setChooseDirectorateOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null)
        setChooseDepartmentOption(null)
        setChooseStructureTypeOption(null);
      });

  }



  const handleChangeDirectorateNames = (value) => {
    setChooseDirectorateOption(value);
    filterInputsUpdate("structureId", value ? value.value : "");

    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP&id=${value ? value.value : ""}`)
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type
        }))

        const newDepartmentItem = displayTypes.filter(obj => {
          return obj.type === 'DEPARTMENT';
        });
        const newBranchItem = displayTypes.filter(obj => {
          return obj.type === 'BRANCH';
        });
        const newDivisionItem = displayTypes.filter(obj => {
          return obj.type === 'DIVISION';
        });
        const newStructureTypeItem = displayTypes.filter(obj => {
          return obj.type === 'STRUCTURE_TYPE';
        });
        setDepartment(newDepartmentItem);

        setBranch(newBranchItem);
        setDivision(newDivisionItem)
        setStructureType(newStructureTypeItem)
        setChooseDepartmentOption(null)

        setChooseBranchOption(null);
        setChooseDivisionOption(null)
        setChooseStructureTypeOption(null);
      });

  };

  const handleChangeDepartmentNames = (value) => {
    setChooseDepartmentOption(value);
    filterInputsUpdate("structureId", value ? value.value : "");

    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP&id=${value ? value.value : ""}`)
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type
        }))


        const newBranchItem = displayTypes.filter(obj => {
          return obj.type === 'BRANCH';
        });
        const newDivisionItem = displayTypes.filter(obj => {
          return obj.type === 'DIVISION';
        });
        const newStructureTypeItem = displayTypes.filter(obj => {
          return obj.type === 'STRUCTURE_TYPE';
        });

        setBranch(newBranchItem);
        setDivision(newDivisionItem)
        setStructureType(newStructureTypeItem)

        setChooseBranchOption(null);
        setChooseDivisionOption(null)
        setChooseStructureTypeOption(null);
      });


  };



  const handleChangeBranchNames = (value) => {
    setChooseBranchOption(value);
    filterInputsUpdate("structureId", value ? value.value : "");

    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP&id=${value ? value.value : ""}`)
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type
        }))

        const newDivisionItem = displayTypes.filter(obj => {
          return obj.type === 'DIVISION';
        });
        const newStructureTypeItem = displayTypes.filter(obj => {
          return obj.type === 'STRUCTURE_TYPE';
        });
        setDivision(newDivisionItem)
        setStructureType(newStructureTypeItem)

        setChooseDivisionOption(null)
        setChooseStructureTypeOption(null);
      });

  };

  const handleChangeDivisionNames = (value) => {
    setChooseDivisionOption(value);
    filterInputsUpdate("structureId", value ? value.value : "");


    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP&id=${value ? value.value : ""}`)
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type
        }))


        const newStructureTypeItem = displayTypes.filter(obj => {
          return obj.type === 'STRUCTURE_TYPE';
        });
        setStructureType(newStructureTypeItem)
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeStructureTypeNames = (value) => {
    setChooseStructureTypeOption(value);
    filterInputsUpdate("structureId", value ? value.value : "");
  };


  const [open, setOpen] = React.useState(false);

  function handleClose() {
    setOpen(false);
  }

  function handleOpen() {
    setOpen(true);
  }
  const [openStatus, setOpenStatus] = React.useState(false);

  function handleCloseStatus() {
    setOpenStatus(false);
  }

  function handleOpenStatus() {
    setOpenStatus(true);
  }


  const onResetFilter = () => {
    setFilterInputs({
      duty: "",
      status: "",
      employeeDeviceStatus: "",
      surname: "",
      name: "",
      middleName: "",
      pin: "",
    });
    setChooseStructureIdOption(null)
    setChooseDirectorateOption(null);
    setChooseDepartmentOption(null);
    setChooseBranchOption(null);
    setChooseDivisionOption(null)
    setChooseStructureTypeOption(null);
    onHide(false)

  }

  return (
    <Modal
      size="xl"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Əməkdaşlar üzrə hesabat filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">

            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={structureId}
                  handleChangeSingle={(value) => handleChangeStructure(value)}
                  single={chooseStructureIdOption}
                  label="Şirkət  seçin"
                  placeholder="Şirkət seçin"
                  inputId="structureId"
                />
              </div>
            </div>

            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={directorate}
                  handleChangeSingle={(value) => handleChangeDirectorateNames(value)}
                  single={chooseDirectorateOption}
                  label="Direktorluq  seçin"
                  placeholder="Direktorluq seçin"
                  inputId="Directorate"
                />
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={department}
                  handleChangeSingle={(value) => handleChangeDepartmentNames(value)}
                  single={chooseDepartmentOption}
                  label="Departament  seçin"
                  placeholder="Departament seçin"
                  inputId="department"
                />
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={branch}
                  handleChangeSingle={(value) => handleChangeBranchNames(value)}
                  single={chooseBranchOption}
                  label="Şöbə  seçin"
                  placeholder="Şöbə seçin"
                  inputId="branch"
                />
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={division}
                  handleChangeSingle={(value) => handleChangeDivisionNames(value)}
                  single={chooseDivisionOption}
                  label="Bölmə seçin"
                  placeholder="Bölmə seçin"
                  inputId="division"
                />
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={structureType}
                  handleChangeSingle={(value) => handleChangeStructureTypeNames(value)}
                  single={chooseStructureTypeOption}
                  label="Struktur növü  seçin"
                  placeholder="Struktur növü seçin"
                  inputId="Struktur növü"
                />
              </div>
            </div>
            {/* <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="role">Vəziyyət</InputLabel>
                  <Select
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={filterInputs.status}
                    onChange={(e) =>
                      filterInputsUpdate("status", e.target.value)
                    }
                    inputProps={{
                      name: "status",
                      id: "status",
                    }}
                  >
                    <MenuItem value="ACTIVE">Aktiv</MenuItem>
                    <MenuItem value="INACTIVE">Deaktiv</MenuItem>

                  </Select>
                </FormControl>
              </div>
            </div> */}

            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="role">Qeydiyyat vəziyyəti </InputLabel>
                  <Select
                    open={openStatus}
                    onClose={handleCloseStatus}
                    onOpen={handleOpenStatus}
                    value={filterInputs.employeeDeviceStatus}
                    onChange={(e) =>
                      filterInputsUpdate("employeeDeviceStatus", e.target.value)
                    }
                    inputProps={{
                      name: "employeeDeviceStatus",
                      id: "employeeDeviceStatus",
                    }}
                  >
                    <MenuItem value="REGISTERED">Qeydiyyatdan keçilmişdir</MenuItem>
                    <MenuItem value="UNREGISTERED">Qeydiyyatdan keçilməmişdir</MenuItem>
                    <MenuItem value="REGISTERED_WITHOUT_DEVICE">Cihazsız Qeydiyyatdan Keçilib</MenuItem>


                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="name"
                  name="name"
                  label="Ad"
                  placeholder="Ad"
                  className="w-100"
                  value={filterInputs.name}
                  onChange={(e) =>
                    filterInputsUpdate("name", e.target.value)
                  }
                // onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="surname"
                  name="surname"
                  label="Soyad"
                  placeholder="Soyad"
                  className="w-100"
                  value={filterInputs.surname}
                  onChange={(e) =>
                    filterInputsUpdate("surname", e.target.value)
                  }

                />
              </div>

            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="middleName"
                  name="middleName"
                  label="Ata adı"
                  placeholder="Ata adı"
                  className="w-100"
                  value={filterInputs.middleName}
                  onChange={(e) =>
                    filterInputsUpdate("middleName", e.target.value)
                  }

                />
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="duty"
                  name="duty"
                  label="Vəzifə"
                  placeholder="Vəzifə"
                  className="w-100"
                  value={filterInputs.duty}
                  onChange={(e) =>
                    filterInputsUpdate("duty", e.target.value)
                  }

                />
              </div>

            </div>
            <div className="col-6 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="pin"
                  name="pin"
                  label="Fin kod"
                  placeholder="Fin kod"
                  className="w-100"
                  value={filterInputs.pin}
                  onChange={(e) =>
                    filterInputsUpdate("pin", e.target.value)
                  }

                />
              </div>
              
            </div>
   

          </div>
          <div className="d-flex justify-content-end">  <Button
            variant="primary"
            onClick={() => {
              onResetFilter();
            }}
            className="mt-4"
          >
            Sıfırla
          </Button>
            <Button
              variant="success"
              onClick={() => {
                onHide(false);
              }}
              className="mt-4 ml-4"
            >
              Tamam
            </Button>
          </div>

        </div>
      </Modal.Body>
    </Modal>
  );
}
